import { render, staticRenderFns } from "./ModalPositionCopy.vue?vue&type=template&id=4a526498&"
import script from "./ModalPositionCopy.vue?vue&type=script&lang=js&"
export * from "./ModalPositionCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports